import React from "react";
import fp from "lodash/fp";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import { CardInfoSection } from "components";

import styles from "./underwritingForm.module.scss";

const UnderwritingForm = ({ decisionData, isFullWidth = false }) => (
	<div className={styles.wrappAutoCheckListForm}>
		<Row>
			<Col xl={isFullWidth ? 12 : 6}>
				<CardInfoSection cardInfoValues={decisionData} />
			</Col>
		</Row>
	</div>
);

export default fp.flow(
	reduxForm({
		destroyOnUnmount: false,
		enableReinitialize: true,
	}),
	connect((_state, { formName, decisionData }) => ({
		form: formName,
		initialValues: decisionData,
	})),
)(UnderwritingForm);
